import { Component } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { MsalService } from './msal';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	isIframe = false;

	constructor(public auth: AuthService, private msalService: MsalService) {
		this.isIframe = window !== window.parent && !window.opener;

		if (!this.isIframe && window.location.pathname !== '/callback') {
			auth.handleAuthentication();
			if (!sessionStorage.getItem('previous_url')) {
				sessionStorage.setItem('previous_url', window.location.pathname);
			}
		}

		this.msalService.handleRedirectObservable().subscribe({
			next: result => {
				if (result) {
					this.auth.handleAuthentication(result.account);
				}
			},
		});
	}
}
